<template>
  <div class="backTop" @click="backToTop()">
    <div class="backTop__action">
      <div class="backTop__action__item">
        <img src="@/assets/image/backtop.png" alt="返回顶部" width="100%" srcset="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BackTop',
    data() {
      return {
        visible: false,
        interval: null,
        isMoving: false,
      };
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    methods: {
      handleScroll() {
        this.visible = window.pageYOffset > 100;
      },
      backToTop() {
        if (this.isMoving) return;
        const start = window.pageYOffset;
        let i = 0;
        this.isMoving = true;
        this.interval = setInterval(() => {
          const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
          if (next <= 0) {
            window.scrollTo(0, 0); // x ,y
            clearInterval(this.interval);
            this.isMoving = false;
          } else {
            window.scrollTo(0, next);
          }
          i++;
        }, 10);
      },
      easeInOutQuad(t, b, c, d) {
        if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      },
    },
  }
</script>

<style lang="scss">
  .backTop {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 8px;
    cursor: pointer;

    &__action {
      flex-shrink: 0;

      &__item {
        width: 32px;
        height: 32px;
      }
    }
  }
</style>